import { Skeleton } from '@crossnokaye/ux-common';

interface SkeletonCollapsedNavProps {
  numberOfSkeletons: number;
}

export const SkeletonCollapsedNav = ({ numberOfSkeletons }: SkeletonCollapsedNavProps) => {
  return (
    <div className={'flex flex-col gap-2 items-center'}>
      {Array(numberOfSkeletons)
        .fill(0)
        .map((_, index) => (
          <Skeleton
            key={index}
            className={
              'w-[3.75rem] h-[3.375rem] pt-[0.75rem] rounded flex-col justify-start items-center gap-[0.1rem] inline-flex bg-popover'
            }
          />
        ))}
    </div>
  );
};
